import type { ICellRendererParams } from "ag-grid-enterprise";

export const MASKED_CELL_CLASS = "ag-grid-masked-cell";
export const MASKED_CELL_REVEALED_CLASS = "ag-grid-masked-cell--revealed";

const MASKED_TITLE = "Click to reveal";
const REVEALED_TITLE = "Click to hide";

// Reveal state rides on the row data: AG-Grid destroys cell components on scroll.
function revealedFlags(params: ICellRendererParams): Record<string, boolean> {
  const data = params.data as Record<string, unknown> | undefined;
  if (!data) return {};
  data.__revealedMaskedCells ??= {};
  return data.__revealedMaskedCells as Record<string, boolean>;
}

// Only one cell is ever unblurred, across every grid on the page.
let activeReveal: { flags: Record<string, boolean>; key: string } | null = null;

function hideActiveReveal(): void {
  if (activeReveal) {
    activeReveal.flags[activeReveal.key] = false;
    activeReveal = null;
  }
  document.querySelectorAll<HTMLElement>(`.${MASKED_CELL_REVEALED_CLASS}`).forEach((el) => {
    el.classList.remove(MASKED_CELL_REVEALED_CLASS);
    el.title = MASKED_TITLE;
  });
}

export function applyCellMask(el: HTMLElement, params: ICellRendererParams, key: string): void {
  el.classList.add(MASKED_CELL_CLASS);
  const flags = revealedFlags(params);

  const sync = () => {
    const revealed = flags[key] === true;
    el.classList.toggle(MASKED_CELL_REVEALED_CLASS, revealed);
    el.title = revealed ? REVEALED_TITLE : MASKED_TITLE;
  };
  sync();

  el.addEventListener("click", (event) => {
    event.stopPropagation();
    const wasRevealed = flags[key] === true;
    hideActiveReveal();
    if (!wasRevealed) {
      flags[key] = true;
      activeReveal = { flags, key };
    }
    sync();
  });
}

export function buildMaskedSpan(
  text: string,
  params: ICellRendererParams,
  key: string
): HTMLElement {
  const el = document.createElement("span");
  el.textContent = text;
  if (text) applyCellMask(el, params, key);
  return el;
}
